import React from 'react';
import { useUpdateEpdLcaSupport } from 'services/api/mutations';
import { FieldPanelFullWidth, FieldPanelHeader } from 'styles/v2/Styles.styled';
import LcaPractitionersSelector from './lca-practitioner-selector/LcaPractitionersSelector';
import { CompilerCompositeStatusModel, LcaSupportModel } from 'types/types';

const LcaSupportPanel: React.FunctionComponent<{
  epdId: string;
  epdVersionId: string;
  lcaSupportInformation: LcaSupportModel;
  validationState: CompilerCompositeStatusModel;
}> = ({ epdId, epdVersionId, lcaSupportInformation, validationState }) => {
  const updateMutation = useUpdateEpdLcaSupport(epdVersionId);

  const onChangeLcaSupport = async (propertyName: string, val: any) => {
    updateMutation.mutate({ epdId, versionId: epdVersionId, propertyName: propertyName, newValue: val });
  };

  return (
    <FieldPanelFullWidth>
      <FieldPanelHeader>LCA support</FieldPanelHeader>
      <LcaPractitionersSelector
        epdId={epdId}
        epdVersionId={epdVersionId}
        practitioners={lcaSupportInformation?.epdDevelopers ?? []}
        onChanged={onChangeLcaSupport}
        validationState={validationState}
      />
    </FieldPanelFullWidth>
  );
};

export default LcaSupportPanel;
